module.exports = __webpack_public_path__ + "static/img/格物智安工地安全管理平台操作说明-14.1626c3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/格物智安工地安全管理平台操作说明-14.jpg
// module id = Fwc9
// module chunks = 0